window.addEventListener('DOMContentLoaded', function(e) {
    let galleries = document.querySelectorAll('section.gallery-section');
    if (galleries) {
        for (let i = 0 ; i < galleries.length ; i++) {
            // Loop through galleries to attach event listeners
            let galleryType = galleries[i].querySelector('.container').children[0].classList[0];
            if (galleryType == 'grid') {
                // Grid galleries have a zoom effect on click
                let images = galleries[i].querySelectorAll('img'); // Clickable images
                let zoomed = galleries[i].querySelector('.zoomed-img');
                let zoomedImg = zoomed.querySelector('img');
                let close = zoomed.querySelector('.close');
                for (let h = 0 ; h < images.length ; h++) {
                    images[h].addEventListener('click', function(e) {
                        zoomedImg.setAttribute('src', e.currentTarget.getAttribute('src'));
                        zoomed.classList.toggle('active');
                    })
                }
                close.addEventListener('click', function(e) {
                    zoomed.classList.toggle('active');
                })
            }
            else {
                // Thumbnail galleries replace the main image on click
                let images = galleries[i].querySelectorAll('.thumb'); // Clickable thumbnails
                for (let j = 0 ; j < images.length ; j++) {
                    images[j].addEventListener('click', function(e) {
                        // Check if image is not already main image
                        let main = galleries[i].querySelector('.main.active');
                        let mainAlt = galleries[i].querySelector('.main:not(.active)');
                        if (e.currentTarget.getAttribute('src') != main.getAttribute('src')) {
                            // Swap the source of the non-showing main image
                            mainAlt.setAttribute('src', e.currentTarget.getAttribute('src'));
                            // Trigger the animation and swap with class toggles
                            main.classList.toggle('active');
                            mainAlt.classList.toggle('active');
                        }
                    })
                }
                // Thumnail galleries also have option for auto-advance
                let galleryContainer = galleries[i].querySelector('.container').children[0];
                if (galleryContainer.classList[1]) {
                    let delay = galleryContainer.getAttribute('data-rate') * 1000;
                    setInterval(function(e) {
                        // get current image position in gallery
                        let src = galleries[i].querySelector('.main.active').getAttribute('src');
                        let curr = galleries[i].querySelector(`img.thumb[src='${src}'`);
                        if (curr.nextElementSibling) {
                            curr.nextElementSibling.click();
                        }
                        else {
                            galleries[i].querySelector('img.thumb').click();
                        }
                    }, delay);
                }
            }
        }
    }
})